export default "__VITE_ASSET__CC1jmhd3__"